<template>
  <commona :data="config"></commona>
</template>
<script>
import commona from "./commona.vue";
export default {
  components: { commona },
  data() {
    return {
      config: {
        title: '保养费用',
        urlKey: '/care',
        formId: 'baoyang',
        item: {
          carId: 0,
          carNo: "",
          careCost: 0,
          careDate: Date.now(),
          cardNo: "",
          mileage: 0,
          proofList: [],
          careStation: "",
          careVolume: 0,
          remainVolume: 0,
          remark: "",
          type: "",
          unitPrice: 0,
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pay/carcare.vue